export default __webpack_public_path__ + "static/media/img-consumer-wallet-app-banner-new-2.c38bd6e7.png";